import { render } from "./Contact.vue?vue&type=template&id=40b11d5a&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=40b11d5a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-40b11d5a"

export default script